import { useContext, useState } from 'react';
import { List, ListItemButton, ListItemText, Menu, MenuItem } from '@mui/material';
import { MdSettings as AdminMenuIcon } from 'react-icons/md';
import { Link as RouterLink } from 'react-router-dom';
import { appUserContext } from 'helpers/services';


let AdminMenu = () => {
    let appUserService = useContext(appUserContext);
    let [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    let handleOpen = (e: any) => {
        setAnchorEl(e.currentTarget);
    }

    let onClose = () => {
        setAnchorEl(null);
    }


    return (
        <>
            <List component="nav" disablePadding>
                <ListItemButton onClick={(e) => handleOpen(e)}>
                    <ListItemText primary={<AdminMenuIcon />} />
                </ListItemButton>
            </List>

            <Menu
                anchorEl={anchorEl}
                keepMounted
                open={anchorEl !== null}
                onClose={onClose}
            >
                {(appUserService.currentUser?.simecClaims?.canManageSimecUsers === true
                    || appUserService.currentUser?.simecClaims?.canManageCanGoToCustomerSimecUsers === true
                ) &&
                    <MenuItem component={RouterLink} to="/users" onClick={onClose}>Users</MenuItem>
                }
                {appUserService.currentUser?.simecClaims?.canManageSimecUsers === true &&
                    <MenuItem component={RouterLink} to="/usergroups" onClick={onClose}>User Groups</MenuItem>
                }
                {appUserService.currentUser?.simecClaims?.canManageTicketCategories === true &&
                    <MenuItem component={RouterLink} to={'/ticketcategories'} onClick={onClose}>Ticket categories</MenuItem>
                }
                {appUserService.currentUser?.simecClaims?.canManageToolTypologies === true &&
                    <MenuItem component={RouterLink} to={'/tooltypologies'} onClick={onClose}>Tipologie Strumenti</MenuItem>
                }
            </Menu>
        </>
    )
}

export default AdminMenu;